import arabellaPic from "@/public/images/artists/arabella.png";
import { Artist } from "@/types/types";

export const arabella = {
  id: "134",
  name: "Arabella",
  image: arabellaPic,
  description: `Arabella's voice is soft and airy with an ethereal quality. While not overpowering, her tones weave through intricate jazz harmonies and indie tunes with ease, giving any vocal a more mellow and serene execution.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Farabella-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Jazz", "Ethereal", "Indie", "Alternative", "Airy"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 72,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
